import actionTypes from 'constants/actionTypes'
import * as auth from './auth'
import * as errors from './errors'
import * as bookmarks from './bookmarks'
import * as edges from './edges'
import * as graph from './graph'
import * as kinds from './kinds'
import * as me from './me'
import * as nodes from './nodes'
import * as pending from './pending'
import * as confirm from './confirm'
import * as users from './users'
import * as prompt from './prompt'
import * as contentGeneration from './contentGeneration'
import * as graphQuery from './graphQuery'

type ResetConfirmState = {
  graph?: {
    nodes?: {
      all?: Record<string, unknown>
    }
    edges?: {
      all?: Record<string, unknown>
    }
  }
  pendingActions?: {
    actions?: unknown[]
  }
}


export {
  auth,
  errors,
  bookmarks,
  edges,
  graph,
  kinds,
  me,
  nodes,
  pending,
  confirm,
  users,
  prompt,
  contentGeneration,
  graphQuery
}

export const reset = () => {
  return {
    type: actionTypes.RESET,
    meta: {
      confirm: (state: ResetConfirmState) => {
        const hasNodes = Object.keys(state.graph?.nodes?.all || {}).length > 0
        const hasEdges = Object.keys(state.graph?.edges?.all || {}).length > 0
        const hasPending = (state.pendingActions?.actions?.length || 0) > 0
        if (!(hasNodes || hasEdges || hasPending)) {
          return null
        }
        return 'Are you sure you want to clear the graph?'
      }
    }
  }
}

export const resetWithoutConfirm = () => {
  return {
    type: actionTypes.RESET
  }
}
